import { render, staticRenderFns } from "./RoomLists.vue?vue&type=template&id=a8a04848&"
import script from "./RoomLists.vue?vue&type=script&lang=js&"
export * from "./RoomLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports